
import {
  createComponent,
  reactive,
  computed,
  inject
} from "@vue/composition-api";
import ResultStoreKey from "./result-store-key";

type Props = {
  romanDataList: [{}];
};

export default createComponent({
  props: {
    romanDataList: {
      type: Array,
      default: []
    }
  },
  setup(props: Props) {
    const resultStore = inject(ResultStoreKey);
    if (!resultStore) {
      throw new Error(`${ResultStoreKey} is not provided`);
    }

    const state = reactive({
      romanDataList: computed(() => props.romanDataList)
    });

    return {
      state
    };
  }
});
